import { Box, Button, Grid, HStack, Heading, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import React from 'react'
import cursor from '../../../assets/images/cursor.png'
import Slidebar from '../Slidebar'
import { RiDeleteBin7Fill } from 'react-icons/ri'
const Users = () => {
  const users=[
    {
_id:"asdfdasfasd",
name:"Sahil",
role:"admin",
subscription:{
  status:"active"
},
email:"sahiltiwari1222@gmail.com"
    }
  ]
  const updateHandler=userId=>{
    console.log(userId)
  }
  const deleteButtonHandler=userId=>{
    console.log(userId)
  }
  return (
    <Grid minH={'100vh'} css={{cursor:`url(${cursor}),default`}} templateColumns={['1fr','5fr 1fr']}>
    <Box p={['0','16']} overflowX='auto' >
<Heading textTransform={'uppercase'} children="All Users" my='16' textAlign={['center','left']}  />
<TableContainer w={['100vw','full']}>
  <Table variant={'simple'} size='lg' >
    <TableCaption>All available users in the databse</TableCaption>

    <Thead>
      <Tr>
<Th>Id</Th>
<Th>Name</Th>
<Th>Email</Th>
<Th>Roles</Th>
<Th>Subscription</Th>
<Th isNumeric>Action</Th>
<Heading/>

      </Tr>
    </Thead>

    <Tbody>

{
  users.map(item=>(
    <Row updateHandler={updateHandler} deleteButtonHandler={deleteButtonHandler} key={item._id} item={item} />
  ))
}
    </Tbody>
  </Table>
</TableContainer>
    </Box>
    <Slidebar/>
</Grid>
  )
}

export default Users
function Row({item,updateHandler,deleteButtonHandler}){
  return (
    <Tr>
<Td>{item._id}</Td>
<Td>{item.name}</Td>
<Td>{item.email}</Td>
<Td>{item.role}</Td>
<Td>{item.subscription.status === 'active'? "Active":"Not Active"}</Td>
<Td isNumeric>
  <HStack justifyContent={'flex-end'}>
<Button onChange={()=>updateHandler(item._id)} variant={'outline'} color="purple.500">Change Role</Button>
<Button onChange={()=>deleteButtonHandler(item._id)} color={'purple.600'}>
  <RiDeleteBin7Fill/>
</Button>
  </HStack>
</Td>
    </Tr>
  )
}